module.exports = __webpack_public_path__ + "static/media/restaurante.6f300838.jpg";